$.nette.init();

NProgress.configure({
    showSpinner: true
});

$.nette.ext('nprogress', {
    start: function () {
        window.NProgress.start();
    },
    complete: function () {
        window.NProgress.done();
    }
});
$("p").filter('[data-f-id="pbf"]').remove();
$.nette.ext("modals", {
    before: function () {
        this.wasModalOpenedBeforeAjaxRequest = this.isModalOpened();
    },
    success: function (payload) {
        if (payload.isModal) {
            if (!this.wasModalOpenedBeforeAjaxRequest) {
                $('.modal-ajax').modal('show');
            } else {
                $('.modal-ajax').addClass('in').css({'display': 'block'}).modal('show');
                $('.modal-backdrop').removeClass('fade');
                $('.modal-backdrop:not(:last)').remove();
                window.setTimeout(function () {
                    $('.modal-backdrop').addClass('fade');
                }, 200);
            }
        } else {
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
            $('.modal-ajax').modal('hide');
        }

        if(payload.modalFormErrors) {
            payload.modalFormErrors.forEach(e => {
                $('.modal-errors').append('<p>' + e +'</p>');
            });
        }else{
            $('.modal-errors').empty();
        }
    }
}, {
    wasModalOpenedBeforeAjaxRequest: false,
    isModalOpened: function () {
        return ($('.modal.fade.in').length > 0);
    }
});

ScrollReveal({
    reset: false,
    duration: 800,
    delay: 100,
    mobile: true,
    scale: 0.90,
    origin: 'top',

    beforeReveal: function(el) {
        let elements = el.getElementsByClassName('lpf-animated');

        Array.from(elements).forEach(
            function(element, index, array) {
                element.classList.remove('remove-animation');
            }
        );
    },
}).reveal('.scrollreveal');